<template>
  <form-group :validator="v" :label="$t('BusinessName')">
      <div class="business_block">
          <input type="text" class="input" name="business" 
          :placeholder="$t('Suchas')" v-model="businessName"
          @input="v.$touch()"/>
        </div>
  </form-group>
</template>

<script>
import { mapState } from "vuex";
import { Stream } from "stream";
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    v: {
      type: Object,
      required: true
    }
  },
  computed: {
    businessName: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  }
};
</script>
